const GithubIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='none'
		height='36'
		viewBox='0 0 36 36'
		width='36'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M18.3164 0.979005C8.65625 0.975099 0.832031 8.79541 0.832031 18.4478C0.832031 26.0806 5.72656 32.5689 12.543 34.9517C13.4609 35.1821 13.3203 34.5298 13.3203 34.0845V31.0571C8.01953 31.6782 7.80469 28.1704 7.44922 27.5845C6.73047 26.3579 5.03125 26.0454 5.53906 25.4595C6.74609 24.8384 7.97656 25.6157 9.40234 27.7212C10.4336 29.2485 12.4453 28.9907 13.4648 28.7368C13.6875 27.8189 14.1641 26.9985 14.8203 26.3618C9.32812 25.3774 7.03906 22.0259 7.03906 18.0415C7.03906 16.1079 7.67578 14.3306 8.92578 12.897C8.12891 10.5337 9 8.51026 9.11719 8.20947C11.3867 8.00635 13.7461 9.83448 13.9297 9.97901C15.2187 9.63135 16.6914 9.44776 18.3398 9.44776C19.9961 9.44776 21.4727 9.63916 22.7734 9.99072C23.2148 9.65479 25.4023 8.08447 27.5117 8.27588C27.625 8.57666 28.4766 10.5532 27.7266 12.8853C28.9922 14.3228 29.6367 16.1157 29.6367 18.0532C29.6367 22.0454 27.332 25.4009 21.8242 26.3696C22.296 26.8336 22.6706 27.3869 22.9261 27.9972C23.1816 28.6075 23.313 29.2627 23.3125 29.9243V34.3189C23.3437 34.6704 23.3125 35.0181 23.8984 35.0181C30.8164 32.686 35.7969 26.1509 35.7969 18.4517C35.7969 8.79541 27.9687 0.979005 18.3164 0.979005Z'
			fill='currentColor'
		/>
	</svg>
)

export { GithubIcon }
